import { render, staticRenderFns } from "./Mainbar.vue?vue&type=template&id=5252cf6c&scoped=true"
import script from "./Mainbar.vue?vue&type=script&lang=js"
export * from "./Mainbar.vue?vue&type=script&lang=js"
import style0 from "./Mainbar.vue?vue&type=style&index=0&id=5252cf6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5252cf6c",
  null
  
)

export default component.exports